export default __webpack_public_path__ + "static/media/caseEcom.78b3de05.png";